<template>
  <router-view/>
</template>

<style>
:root{
    --bodybg:rgb(255, 255, 255);
    --petrol1:#00649e;
    --petrol2:#3983a8;
    --logo:#2c2e33;
    --yazilar:#2c2e33;
    
}

html,body{
  font-family: forma-djr-text, sans-serif !important;
    font-weight: 400 !important;
    font-style: normal !important;
    letter-spacing: 0.05rem !important;
}
#app {
  
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
